import React from "react";
import Grid from "@material-ui/core/Grid";
import "./DisplayUploadedDocuments.scss";
import deleteFile from "../../../../assets/deletefileupload.svg";
import downloadFile from "../../../../assets/downloadfileupload.svg";

const DisplayUploadedDocuments = ({
  data,
  fileName,
  fileType,
  downloadUrl,
  handleDelete,
  handleDownload,
}) => {
  return (
    <div className="display-uploaded-documents">
      <Grid container spacing={1}>
        <Grid item md={8} xs={10} className="dud-filename">
          <div className="d-flex flex-column">
            {window.innerWidth > 767
              ? fileName?.length > 10
                ? fileName + "..."
                : fileName
              : fileName?.length > 20
              ? fileName + "..."
              : fileName}
            <br />
            <div className="dud-filetype">{fileType}</div>
          </div>
        </Grid>
        <Grid item md={2} xs={1} className="dud-download">
          <img
            src={downloadFile}
            onClick={() => handleDownload(downloadUrl, fileName, fileType)}
            alt=""
          />
        </Grid>
        <Grid item md={2} xs={1} className="dud-delete">
          <img src={deleteFile} onClick={() => handleDelete(data)} alt="" />
        </Grid>
      </Grid>
    </div>
  );
};
export default DisplayUploadedDocuments;
